import TiptapTableRow from '@tiptap/extension-table-row';
import { mergeAttributes } from '@tiptap/core';
import { keepStyles } from './utils';

export const TableRow = TiptapTableRow.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: null },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'tr',
        getAttrs: (dom) => {
          const style = dom.getAttribute('style');
          return style ? { style } : {};
        },
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['tr', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
});

export default TableRow;
